module.exports = __webpack_public_path__ + "static/img/img_2.2334966.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/site/programme_resource_management/img_2.jpg
// module id = rMH2
// module chunks = 0